
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/index.md?type=demo')
};